import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "White",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 400 400"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("mask", { id: "envelope" }, [
        _createElementVNode("rect", {
          width: "100%",
          height: "100%",
          fill: "#fff"
        }),
        _createElementVNode("path", {
          fill: "none",
          stroke: "#000",
          "stroke-width": "18",
          d: "M64 102h272v196H64V102l136 98 136-98"
        })
      ])
    ], -1),
    _createElementVNode("circle", {
      cx: "200",
      cy: "200",
      r: "200",
      mask: "url(#envelope)"
    }, null, -1)
  ]))]))
}
export default { render: render }